/// <reference path="../../apollo-client-default-options.d.ts" />

import { enableProdMode } from '@angular/core';

import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';

import { AppModule } from './app.module';
import { environment } from '@env/environment';
import { platformBrowser } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
} else {
  loadDevMessages();
  loadErrorMessages();
}

platformBrowser()
  .bootstrapModule(AppModule)
  .then(module => {
    window['rootInjector'] = module.injector;
  })
  .catch(err => console.log(err));

if ('serviceWorker' in navigator && environment.registerServiceWorker) {
  navigator.serviceWorker.register('/ngsw-worker.js');
}
